module.exports = __webpack_public_path__ + "img/brands-wasa-rye.jpg?2a6fdcf7ae6cb1768acd710d8495757e";